export default {
  constructionDocuments: 'Construction Documents',
  objects: 'objekt',
  name: 'Namn',
  modified: 'Modifierad',
  size: 'Storlek',
  loading: 'Laddar...',
  errorMessages: {
    unknownError: 'Något gick fel. Uppdatera sidan!',
    noFilesFound: 'Inga filer eller mappar hittades för detta projekt.',
    chooseProjectIfs: 'Välj projekt IFS för att öppna dokument.',
    emptyFolder: 'Tom mapp',
  },
  downloadFileConfirmationModal: {
    title: 'Ladda ner fil',
    body: 'Är du säker på att du vill ladda ner följande fil?',
    cancel: 'Avbryt',
    proceed: 'Ladda ner',
  },
  toast: {
    errorReload: 'Ladda om sidan och försök igen!',
  },
  sharepointExport: {
    sharepointExport: 'Sharepoint Export',
    exportAllReady: 'Exportera alla redo',
    refreshHcs: 'Synka HCs',
    refresh: 'Uppdatera',
    help: 'Hjälp',
    table: {
      columns: {
        reportType: 'Rapporttyp',
        totalAmount: 'Totalt antal',
        readyToExport: 'Ej exporterad',
        status: 'Status',
        inProgress: 'I kö',
        exported: 'Exporterad',
        failed: 'Misslyckades (ej exporterad)',
      },
      reportType: {
        CABINET: 'Skåp',
        WORK_VARIATION: 'ÄTA',
        HUB: 'HUB',
        HC: 'HC',
        HP: 'HP',
        LAND_AGREEMENT: 'Markavtal',
        LAND_SURVEY: 'Inmätningar',
        SITE: 'Site',
        SPAN: 'Stråk',
        MANHOLE: 'Brunn',
        MDU_BUILDING: 'Byggnad',
        MDU_DELIVERY_POINT: 'Leveranspunkter',
      },
      status: {
        NONE: ' ',
        READY: 'Redo',
        COMPLETED: 'Slutförd',
        IN_PROGRESS: 'Pågår',
      },
      exportButton: {
        EXPORTING: 'Exporterar',
        NOT_READY: 'Exportera',
        SOME_READY: 'Exportera',
        ALL_COMPLETED: 'Exportera',
        ALL_READY: 'Exportera',
      },
    },
    helpModal: {
      title: 'Sharepoint Export',
      intro: {
        title: 'Exportera till Sharepoint från DeliveryPortal',
        body: 'Exportera färdiga rapporter som PDF-filer från DeliveryPortal till Sharepoint.',
      },
      howItWorks: {
        title: 'Hur det fungerar',
        body: 'Du kan endast exportera färdiga rapporter (se nedan). Rapporterna kategoriseras efter typ, och du kan följa exportens status i tabellen. När du exporterar rapporter så körs det i bakgrunden. Du kan stänga DeliveryPortal och återkomma senare för att kontrollera resultaten. Klicka på "Uppdatera" för att uppdatera tabellen – exportens detaljer uppdateras inte automatiskt.',
      },
      exportableReportsCompleted: {
        title: 'Exportbara rapporter (färdiga)',
        body: 'Varje rapport har en specifik "definition of done" som beskriver vad som behöver vara klart för att påbörja exporten. Kontrollera förklaringarna för varje rapporttyp.',
        reportType: {
          HP: 'HP - House passed',
          HC: 'HC - House connected',
          CABINET: 'Skåp / FOS',
          MANHOLE: 'Brunn',
          HUB: 'HUB',
          SITE: 'Site',
          SPAN: 'Spans',
        },
        dod: {
          STATUS_DONE: 'Har status Klar',
          STATUS_RESTORED: 'Har status Återställd',
          FILLED_AND_PERFORMED:
            'Alla utförda datum ifyllda och alla obligatoriska egenkontroller genomförda',
        },
      },
      tableDetails: {
        title: 'Tabelldetaljer',
        totalAmount: 'Totalt antal',
        totalAmountInfo: 'Antal rapporter av typen i projektet',
        unexported: 'Ej exporterad',
        unexportedInfo: 'Antal färdiga rapporter som kan exporteras',
        status: 'Status',
        statusInfo: 'Exportstatus (Redo, Pågår, Slutförd)',
        other: 'I kö / Exporterad / Misslyckades',
        otherInfo: 'Antal exporterade rapporter',
      },
      statusForExport: {
        title: 'Status för export',
        READY: 'Redo',
        READYInfo: 'Rapporter av typen är redo att exporteras',
        IN_PROGRESS: 'Pågår',
        IN_PROGRESSInfo: 'Exporten körs i bakgrunden',
        COMPLETED: 'Slutförd',
        COMPLETEDInfo: 'Exporten av alla rapporter lyckades',
        NONE: '(tomt)',
        NONEInfo: 'Inga rapporter redo för export',
      },
    },

    overwriteReportsConfirmationModal: {
      title: 'Rapporter kommer att skrivas över',
      confirm: 'Bekräfta export',
      cancel: 'Avbryt',
      body: 'Rapporter som redan har exporterats till Sharepoint kommer att ersättas.',
    },
    loading: {
      pleaseWait: 'Laddar sida. Vänligen vänta...',
    },
    error: 'Något fick fel. Försök igen!',
    alerts: {
      exportStarted: 'Export startad',
      exportFailed: 'Kunde inte starta export. Försök igen.',
      refreshSuccess: 'HC synk lyckades.',
      refreshFailed: 'HC synk misslyckades.',
    },
  },
};
